import { FC } from "react";

import { Planner } from "./Planner";

import { ContentSidebarHeader } from "components/materials/sidebar/ContentSidebarHeader";
import { ContentSidebarMain } from "components/materials/sidebar/ContentSidebarMain";
import { getSidebarHeader } from "helpers/sidebar";
import { HorizontalDivider } from "mds/components/HorizontalDivider";
import { CONTENT_SIDEBAR_TAB_NAME } from "utils/urls";

interface PlannerSidebarPanelProps {
  scrollTrackingId?: string;
}

export const PlannerSidebarPanel: FC<PlannerSidebarPanelProps> = ({ scrollTrackingId }) => {
  return (
    <>
      <ContentSidebarHeader className="flex-col">
        {getSidebarHeader(CONTENT_SIDEBAR_TAB_NAME.Planner)}

        <HorizontalDivider className="my-3 -ml-3" />
      </ContentSidebarHeader>

      <ContentSidebarMain className="h-full" scrollTrackingId={scrollTrackingId}>
        <Planner showAll />
      </ContentSidebarMain>
    </>
  );
};
